import * as Types from '../../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type NotificationPreferencesVariables = Types.Exact<{ [key: string]: never }>;

export type NotificationPreferences = {
  notificationPreferences: {
    preferences: Array<
      Pick<Types.NotificationPreference, 'topic'> & {
        channels: Array<Pick<Types.NotificationChannel, 'name' | 'enabled'>>;
      }
    >;
  };
};

export const NotificationPreferencesDocument = gql`
  query NotificationPreferences {
    notificationPreferences {
      preferences {
        topic
        channels {
          name
          enabled
        }
      }
    }
  }
`;

/**
 * __useNotificationPreferences__
 *
 * To run a query within a React component, call `useNotificationPreferences` and pass it any options that fit your needs.
 * When your component renders, `useNotificationPreferences` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationPreferences({
 *   variables: {
 *   },
 * });
 */
export function useNotificationPreferences(
  baseOptions?: Apollo.QueryHookOptions<NotificationPreferences, NotificationPreferencesVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NotificationPreferences, NotificationPreferencesVariables>(
    NotificationPreferencesDocument,
    options,
  );
}
export function useNotificationPreferencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NotificationPreferences,
    NotificationPreferencesVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<NotificationPreferences, NotificationPreferencesVariables>(
    NotificationPreferencesDocument,
    options,
  );
}
export function useNotificationPreferencesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    NotificationPreferences,
    NotificationPreferencesVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<NotificationPreferences, NotificationPreferencesVariables>(
    NotificationPreferencesDocument,
    options,
  );
}
export type NotificationPreferencesHookResult = ReturnType<typeof useNotificationPreferences>;
export type NotificationPreferencesLazyQueryHookResult = ReturnType<
  typeof useNotificationPreferencesLazyQuery
>;
export type NotificationPreferencesSuspenseQueryHookResult = ReturnType<
  typeof useNotificationPreferencesSuspenseQuery
>;
export type NotificationPreferencesQueryResult = Apollo.QueryResult<
  NotificationPreferences,
  NotificationPreferencesVariables
>;
export function mockNotificationPreferences({
  data,
  variables,
  errors,
}: {
  data: NotificationPreferences;
  variables?: NotificationPreferencesVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: NotificationPreferencesDocument, variables },
    result: { data, errors },
  };
}
